import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { StyledEnrichmentErrorContainer } from "./styles";

const EnrichmentErrorState = () => {
    return (
        <I18n
            translatable={{ key: "si.enrichment.error.state.message" }}
            element={StyledEnrichmentErrorContainer}
        />
    );
};

export default EnrichmentErrorState;
